import AppManagerClient from '../../api/AppManagerClient';
import { IManagingWebSitesInstance } from '../../api/models';
import React, { useEffect, useState } from 'react';
import { WebSitesServerManagementView } from './WebSitesServerManagementView';
import { Stack } from 'react-bootstrap';
import { AccordionWrapper } from '../UIExtentions/Accordion';
import { WebSitesEnvironmentComparison } from '../Comparison/WebSitesEnvironmentComparison';

export const WebSitesServerManagement = (props: any) => {
    const [serverApps, setServerApps] = useState(Array<IManagingWebSitesInstance>());
    const [isLoading, setLoadingStatus] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const applicationName = props.applicationName;

    const getServers = async (appName: string) => {
        try {
            const serversResult = await AppManagerClient.getWebSitesForManaging(appName);
            setServerApps(serversResult);
        } catch (err: any) {
            setErrorMessage(err.message);
        } finally {
            setLoadingStatus(false);
        }
    };

    useEffect(() => {
        getServers(applicationName);
    }, [applicationName]);

    return (
        <Stack gap={3}>
            <AccordionWrapper
                fitToSize={true}
                headerIcon="fa-code-compare"
                headerText="Environment Comparison"
                objectName={applicationName}
                isLoading={props.isLoading}
                errorMessage={props.errorMessage}
            >
                <WebSitesEnvironmentComparison data={serverApps} />
            </AccordionWrapper>

            <WebSitesServerManagementView
                serverApps={serverApps}
                userPrincipal={props.userPrincipal}
                isLoading={isLoading}
                errorMessage={errorMessage}
                isDataNotFound={serverApps.length === 0}
                applicationName={applicationName}
            />
        </Stack>
    );
};
